/**
 * Phone bottom bar: four daily destinations + More, chosen by what the company can do.
 * Capabilities come from server-checked entitlements (never a plan name), so the bar
 * follows plan changes automatically. Everything not here lives in the More sheet.
 */
export type MobileTabKey = 'desk' | 'my-listings' | 'my-menu' | 'supplier-menus' | 'buy-requests' | 'messages';

export function mobileTabsFor(caps: { canInventory: boolean; canMenus: boolean }): MobileTabKey[] {
  if (caps.canInventory || caps.canMenus) {
    return ['desk', caps.canInventory ? 'my-listings' : 'supplier-menus', caps.canMenus ? 'my-menu' : 'buy-requests', 'messages'];
  }
  return ['desk', 'supplier-menus', 'buy-requests', 'messages'];
}
